var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price"},[_c('span',{staticClass:"price__sum"},[_vm._v("1690 руб.")]),_vm._v(" "),_c('CButton',{staticClass:"price__sbt"},[_vm._v("Купить")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }